// Menu lateral do backoffice. Cada entrada e um item ({ name, icon, route, path }),
// um grupo com submenu ({ name, icon, children: [itens e subtitulos { header }] })
// ou um titulo de secao ({ section }). `path` e a
// area do perfil de acesso (Administracao > Perfis), conferida com
// $check(path, "GET"); item sem path aparece sempre.
// Grupo sem nenhum item permitido nao aparece.
const data = [
  { name: "Dashboard", icon: "mdi-view-dashboard-outline", route: "/home", path: null },
  { section: "Operação" },
  {
    name: "Créditos",
    icon: "mdi-file-document-multiple-outline",
    children: [
      { name: "Hab/Div", icon: "mdi-sync-alert", route: "/divergencias", path: "Event" },
      { name: "CHC", icon: "mdi-file-certificate-outline", route: "/chc", path: "Event" },
      { name: "Central de Créditos", icon: "mdi-file-tree-outline", route: "/central-analise-creditos", path: "CreditAnalysis" },
      { name: "Análise de Ofício", icon: "mdi-text-box-search-outline", route: "/analise-oficio", path: "LetterAnalysis" },
      { name: "Impugnações", icon: "mdi-gavel", route: "/impugnacoes", path: "Proceedings" },
      { name: "Outros processos", icon: "mdi-briefcase-search-outline", route: "/outros-processos", path: "OtherProceedings" },
      { name: "QGC", icon: "mdi-card-account-details-outline", route: "/qgc", path: "Qgc" },
      { name: "Lista de Credores", icon: "mdi-account-details-outline", route: "/lista-credores", path: "Creditors" },
      { name: "Textos Automáticos (RVC)", icon: "mdi-text-box-outline", route: "/textos-automaticos", path: "DynamicText" },
    ],
  },
  {
    name: "Credores",
    icon: "mdi-account-group-outline",
    children: [
      { name: "Credores", icon: "mdi-account-group-outline", route: "/credores", path: "User" },
      { name: "Procuradores", icon: "mdi-account-tie-outline", route: "/procuradores", path: "Procurator" },
      { name: "Procuração modelo", icon: "mdi-file-sign", route: "/procuradores/procuracao-modelo", path: "Procurator" },
      { name: "Dados Bancários", icon: "mdi-bank-outline", route: "/dados-bancarios", path: "BankInformation" },
      { name: "Correspondências", icon: "mdi-email-fast-outline", route: "/correspondencias", path: "Correspondence" },
    ],
  },
  {
    name: "Assembleia e Plano",
    icon: "mdi-video-outline",
    children: [
      { name: "Assembleia de Credores", icon: "mdi-video-outline", route: "/agcs", path: "GeneralMeeting" },
      { name: "Credenciamentos", icon: "mdi-account-clock-outline", route: "/credenciamentos", path: "Accreditation" },
      { name: "Substabelecimentos", icon: "mdi-account-switch-outline", route: "/agcs-substabelecimentos", path: "GeneralMeeting" },
      { name: "Adesão ao Plano", icon: "mdi-file-sign", route: "/adesao-plano", path: "PlanAdhesion" },
      //{ name: "Votação", icon: "mdi-vote-outline", route: "/votacao-lista", path: "VotingList" },
    ],
  },
  {
    name: "Casos",
    icon: "mdi-briefcase-outline",
    children: [
      { name: "Casos", icon: "mdi-account-file-outline", route: "/casos", path: "Client" },
      { name: "Documentos", icon: "mdi-file-outline", route: "/documentos", path: "Document" },
      { name: "Usuários da Recuperanda", icon: "mdi-account-multiple-check-outline", route: "/usuarios-recuperanda", path: "ClientAdmin" },
      { name: "Comarcas", icon: "mdi-map-marker-distance", route: "/comarcas", path: "District" },
    ],
  },
  {
    name: "Fiscalização mensal",
    icon: "mdi-calendar-check-outline",
    children: [
      { name: "Painel RMA", icon: "mdi-view-dashboard-variant-outline", route: "/fiscalizacao-mensal", path: "Rma" },
      { name: "Tipos de documentos", icon: "mdi-file-cabinet", route: "/fiscalizacao-mensal/tipos", path: "Rma" },
      { name: "Questionário modelo", icon: "mdi-clipboard-list-outline", route: "/fiscalizacao-mensal/questionario", path: "Rma" },
    ],
  },
  {
    name: "Prospecção",
    icon: "mdi-radar",
    children: [
      { header: "Rotina" },
      { name: "Painel", icon: "mdi-view-dashboard-outline", route: "/prospeccao/painel", path: "Prospect" },
      { name: "Casos", icon: "mdi-briefcase-search-outline", route: "/prospeccao/casos", path: "Prospect" },
      { name: "Prazos de TCA", icon: "mdi-timer-sand", route: "/prospeccao/cautelares", path: "Prospect" },
      { name: "Agenda de visitas", icon: "mdi-calendar-account-outline", route: "/prospeccao/agendas", path: "Prospect" },
      { name: "Roteiros de visita", icon: "mdi-map-marker-path", route: "/prospeccao/rota", path: "Prospect" },
      { header: "Análise" },
      { name: "Concorrência", icon: "mdi-podium", route: "/prospeccao/concorrencia", path: "Prospect" },
      { name: "Métricas", icon: "mdi-chart-box-outline", route: "/prospeccao/metricas", path: "Prospect" },
      { header: "Cadastros" },
      { name: "Administradores judiciais", icon: "mdi-domain", route: "/prospeccao/ajs", path: "Prospect" },
      { name: "Juízes e varas", icon: "mdi-gavel", route: "/prospeccao/juizes", path: "Prospect" },
      { name: "Sedes e aeroportos", icon: "mdi-office-building-marker-outline", route: "/prospeccao/sedes", path: "Prospect" },
    ],
  },
  {
    name: "Processo competitivo",
    icon: "mdi-gavel",
    children: [
      { header: "Visão geral" },
      { name: "Painel", icon: "mdi-view-dashboard-outline", route: "/processo-competitivo/painel", path: "Competitive" },
      { header: "Cadastros" },
      { name: "Processos", icon: "mdi-bank-outline", route: "/processo-competitivo/processos", path: "Competitive" },
      { name: "Ativos", icon: "mdi-domain", route: "/processo-competitivo/ativos", path: "Competitive" },
      { name: "Cestas e lotes", icon: "mdi-layers-outline", route: "/processo-competitivo/cestas-e-lotes", path: "Competitive" },
      { name: "Etapas", icon: "mdi-format-list-numbered", route: "/processo-competitivo/etapas", path: "Competitive" },
      { header: "Habilitação" },
      { name: "Inscrições", icon: "mdi-account-check-outline", route: "/processo-competitivo/inscricoes", path: "Competitive" },
      { name: "Data room", icon: "mdi-folder-lock-outline", route: "/processo-competitivo/data-room", path: "Competitive" },
      { header: "Sessão pública" },
      { name: "Abertura e resultados", icon: "mdi-lock-open-variant-outline", route: "/processo-competitivo/sessao-publica", path: "Competitive" },
      { name: "Homologação", icon: "mdi-gavel", route: "/processo-competitivo/homologacao", path: "Competitive" },
      { header: "Controle" },
      { name: "Trilha do certame", icon: "mdi-link-variant", route: "/processo-competitivo/trilha", path: "Competitive" },
    ],
  },
  { section: "Gestão" },
  {
    name: "Site",
    icon: "mdi-web",
    children: [
      { name: "Banner de Aviso", icon: "mdi-invoice-text-clock-outline", route: "/banner-aviso", path: "HomeBanner" },
      { name: "Dúvidas", icon: "mdi-account-question-outline", route: "/faqs", path: "Faq" },
      { name: "Textos Dinâmicos", icon: "mdi-file-chart-outline", route: "/textos-dinamicos", path: "DynamicInfo" },
      { name: "Processos Mais Consultados", icon: "mdi-text-box-search-outline", route: "/processos-mais-consultados", path: "MostConsulted" },
      { name: "Modelo de Documentos", icon: "mdi-file-sign", route: "/modelo-documentos", path: "TemplateDoc" },
      { name: "Postagens do Blog", icon: "mdi-post-outline", route: "/blog/posts", path: "Blog" },
      { name: "Notícias", icon: "mdi-newspaper-variant-outline", route: "/noticias", path: "ClientNews" },
      // { name: "Atos Processuais", icon: "mdi-file-document-edit-outline", route: "/vehicles" },
      // { name: "Habilitações e Divergências", icon: "mdi-text-box-check-outline", route: "/vehicles" },
    ],
  },
  {
    name: "Administração",
    icon: "mdi-cog-outline",
    children: [
      { name: "Administradores", icon: "mdi-account-supervisor-circle-outline", route: "/admins", path: "Admin" },
      { name: "Perfis de acesso", icon: "mdi-shield-account-outline", route: "/perfis", path: "Profiles" },
      { name: "Colaboradores", icon: "mdi-account-multiple-outline", route: "/colaboradores", path: "Employee" },
      { name: "Auditoria", icon: "mdi-shield-search", route: "/auditoria", path: "Audit" },
      { name: "E-mails", icon: "mdi-email-check-outline", route: "/emails", path: "EmailLog" },
    ],
  },
];

export default [...data];
